import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import * as fromCampaign from './campaign.reducer';
import * as fromOption from './option.reducer';
import * as fromBasketRaffle from './basketRaffle.reducer';
import { EffectsModule } from '@ngrx/effects';
import { CampaignEffects } from './campaign.effects';
import { OptionEffects } from './option.effects';
import { BasketRaffleEffects } from './basketRaffle.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(fromCampaign.campaignFeatureKey, fromCampaign.reducer),
    StoreModule.forFeature(fromOption.optionFeatureKey, fromOption.reducer),
    StoreModule.forFeature(fromBasketRaffle.basketRaffleFeatureKey, fromBasketRaffle.reducer),
    EffectsModule.forFeature([CampaignEffects, OptionEffects, BasketRaffleEffects]),
  ]
})
export class CampaignFeatureSModule {
  constructor() {}
}
